import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
  Grid,
  Divider,
  Tooltip,
  IconButton,
  CircularProgress,
  Avatar,
  MenuItem, Select, FormHelperText, FormControl
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { getProductionTeam, getUsersByOrgId } from '../../apis/apiList/userApi';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { createMultipleProject } from '../../apis/apiList/projectApi';
import { useMessage } from '../../context/MessageContext';
import axios from 'axios';

export default function AddMultipleProject({ handleAddProjectShow, organization, handleProjectListChange }) {
  const [customerUsers, setCustomerUsers] = useState([]);
  const [asUsers, setAsUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState({});
  const [vpmaSelectedUsers, setVpmaSelectedUsers] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isVpmaOrgFound, setIsVpmaOrgFound] = useState(true);
  const [error, setError] = useState(null);
  const { showMessage } = useMessage();

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const validationSchema = Yup.object({
    numProjects: Yup.number()
      .min(1, 'Minimum 1 project required')
      .required('Number of projects is required'),
    purchaseDate: Yup.date()
        .required('Start date is required')
        .min(today, 'Start date cannot be in the past'),
    dueDate: Yup.date()
      .nullable()
      .min(today, 'Due date cannot be in the past')
      .required('Due date is required'),
  });

  const formik = useFormik({
    initialValues: {
      numProjects: '',
      purchaseDate: null,
      dueDate: null,
    },
    validationSchema,
    onSubmit: (values) => {
      // const selected = Object.keys(selectedUsers).filter((key) => selectedUsers[key]);
      const vpmaSelected = Object.keys(vpmaSelectedUsers).filter((key) => vpmaSelectedUsers[key]);
      console.log({
        ...values,
        // selectedUsers: [selected, vpmaSelected],
      });
      // handleSubmitProject(values, [...selected, ...vpmaSelected]);
      handleSubmitProject(values, [...vpmaSelected]);
    //   setTimeout(() => {
    //     setIsSubmitting(false);
    //   }, 1500);
    },
  });


  const handleSubmitProject = async (values, selectedIds) => {
    try {
      setIsSubmitting(true);
      // console.log('selectedUsers', selectedUsers)
      console.log('selectedIds', selectedIds)
      console.log('values', values)
      console.log('customerUsers', customerUsers)
      const selectedCustomerDetails = customerUsers.filter(user => selectedIds.includes(String(user.ID)));
      console.log('selectedCustomerDetails', selectedCustomerDetails)
      const selectedAssociationDetails = asUsers.filter(user => selectedIds.includes(String(user.ID)));

      const allSelectedUsers = [...selectedCustomerDetails, ...selectedAssociationDetails];
      console.log('allSelectedUsers', allSelectedUsers)

      console.log('data', values.purchaseDate)
      const date = new Date(values.purchaseDate);
      const utcDate = new Date(Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
      ));
      console.log('utcDate', utcDate)

      const data = {
        orgId: organization._id,
        dueDate: values.dueDate,
        purchaseDate: utcDate,
        videoPackage: values.numProjects,
        selectedUserList: allSelectedUsers,
      }

      try {
          const prjResponse = await createMultipleProject(data)
          console.log('prjResponse', prjResponse);
          if(prjResponse?.success){
            showMessage(prjResponse.message, 'success')
            handleAddProjectShow()
            handleProjectListChange(prjResponse.data)
          }
      } catch (err) {
          console.log(err);
          showMessage(err?.response?.data?.message || 'Something went wrong', 'error');
      }

      setIsSubmitting(false);
    //   handleAddProjectShow();
    } catch (error) {
      console.error('Error submitting project:', error);
      setIsSubmitting(false);
    }
  };
  

  const handleUserChange = (id) => {
    console.log('snapshot id', id)
    console.log('snapshot selectedUsers', selectedUsers)
    setSelectedUsers((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  
  const handleVpmaUserChange = (id) => {
    console.log('id', id)
    console.log('vpmaSelectedUsers', vpmaSelectedUsers)
    setVpmaSelectedUsers((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        // const [prodRes, orgRes] = await Promise.all([
        //   getProductionTeam(),
        //   getUsersByOrgId(organization._id)
        // ]);
        // const prodRes = await getProductionTeam();
        // setAsUsers(prodRes?.data || []);

        // const orgRes = await getUsersByOrgId(organization._id);
        // setCustomerUsers(orgRes?.data || []);

        if(organization.vpmaOrganizationId) {
          setIsVpmaOrgFound(true);
          console.log('organization.vpmaOrganizationId', organization.vpmaOrganizationId)
          const response = await axios.get(`${process.env.REACT_APP_VPMA_BACKEND_URL}/snapshotvideos/user/fetch/by/org/${organization.vpmaOrganizationId}`)
          console.log('response setOrgUserList', response)
          
          setCustomerUsers(response?.data?.data || []);
          setAsUsers(response?.data?.productionTeam || []);
          
        } else {
          const [prodRes, orgRes] = await Promise.all([
            getProductionTeam(),
            getUsersByOrgId(organization._id)
          ]);

          setIsVpmaOrgFound(false);
          console.log('prodRes', prodRes)
          console.log('orgRes', orgRes)

          setCustomerUsers(orgRes?.data || []);
          setAsUsers(prodRes?.data || []);
        }
        setLoading(false);
        setError(null);
      } catch (err) {
        console.error('Failed to fetch data:', err);
        setError('Failed to load team data. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    if (organization) {
      fetchData();
    }
  }, [organization]);


  const handleCancel = () => {
    formik.resetForm();
    setSelectedUsers({});
    handleAddProjectShow();
  };

  const renderUsers = (users, userType) => (
    <FormGroup>
      <Grid container  columns={{ xs: 12, sm: 12, md: 12, lg: 12}} >
          {users.map((user) => (
            <Grid key={user.ID} size={6} width={{sm: '100%', md: '50%'}} marginBottom={'8px'}>
                {/* { xs: 12, sm: 12, md: 12, lg:6 } */}
                <FormControlLabel
                    key={user.ID}
                    control={
                        <Checkbox
                        checked={!!vpmaSelectedUsers[user.ID]}
                        onChange={() => handleVpmaUserChange(user.ID)}
                        />
                    }
                    label={
                        userType == 'production' ?
                          ( 
                            <Box marginBottom={'7px'}>
                              <Box display="flex" alignItems="center">
                                <Avatar
                                    src={`${process.env.REACT_APP_VPMA_FRONTEND_URL}/profile-image/${user.profile_image}`}
                                    alt={`${user.first_name} ${user.last_name}`}
                                    sx={{ width: 30, height: 30, mr: 1 }}
                                />
                                <Box sx={{ lineHeight: 1.3 }}>
                                  {`${user.first_name} ${user.last_name}`}
                                  <Typography variant="body2" color="#606060">{user.job_title}</Typography>
                                </Box>
                              </Box>
                              {/* <Box>
                              </Box> */}
                            </Box>
                          )
                        :
                          (
                            <Box display="flex" alignItems="center">
                              <Avatar
                                  src={`${process.env.REACT_APP_VPMA_FRONTEND_URL}/profile-image/${user.profile_image}`}
                                  alt={`${user.first_name} ${user.last_name}`}
                                  sx={{ width: 30, height: 30, mr: 1 }}
                              />
                              {`${user.first_name} ${user.last_name}`}
                            </Box>
                          )
                    }
                />
            </Grid>
          ))}
      </Grid>
    </FormGroup>
  );
  
  const renderSnapshotUsers = (users, userType) => (
    <FormGroup>
      <Grid container  columns={{ xs: 12, sm: 12, md: 12, lg: 12}} >
          {users.map((user) => (
            <Grid key={user._id} size={6} width={{sm: '100%', md: '50%'}} marginBottom={'8px'}>
                {/* { xs: 12, sm: 12, md: 12, lg:6 } */}
                <FormControlLabel
                    key={user._id}
                    control={
                        <Checkbox
                        checked={!!vpmaSelectedUsers[user._id]}
                        onChange={() => handleVpmaUserChange(user._id)}
                        />
                    }
                    label={
                        userType == 'production' ?
                          ( 
                            <Box marginBottom={'7px'}>
                              <Box display="flex" alignItems="center">
                                <Avatar
                                    src={user?.profilePicture}
                                    alt={`${user.firstName} ${user.lastName}`}
                                    sx={{ width: 30, height: 30, mr: 1 }}
                                />
                                <Box sx={{ lineHeight: 1.3 }}>
                                  {`${user.firstName} ${user.lastName}`}
                                  <Typography variant="body2" color="#606060">{user.jobTitle}</Typography>
                                </Box>
                              </Box>
                              {/* <Box>
                              </Box> */}
                            </Box>
                          )
                        :
                          (
                            <Box display="flex" alignItems="center">
                              <Avatar
                                  src={user?.profilePicture}
                                  alt={`${user.firstName} ${user.lastName}`}
                                  sx={{ width: 30, height: 30, mr: 1 }}
                              />
                              {`${user.firstName} ${user.lastName}`}
                            </Box>
                          )
                    }
                />
            </Grid>
          ))}
      </Grid>
    </FormGroup>
    // <FormGroup>
    //     <Grid container  columns={{ xs: 12, sm: 12, md: 12, lg: 12}}>
    //         {users.map((user) => (
    //             <Grid key={users._id} size={6} width={{sm: '100%', md: '50%'}}>
    //                 {/* { xs: 12, sm: 12, md: 12, lg:6 } */}
    //                 <FormControlLabel
    //                     key={user._id}
    //                     control={
    //                         <Checkbox
    //                         checked={!!vpmaSelectedUsers[user._id]}
    //                         onChange={() => handleVpmaUserChange(user._id)}
    //                         />
    //                     }
    //                     label={
    //                         <Box display="flex" alignItems="center">
    //                             <Avatar
    //                                 src={user.profilePicture}
    //                                 alt={`${user.firstName} ${user.lastName}`}
    //                                 sx={{ width: 30, height: 30, mr: 1 }}
    //                             />
    //                             {`${user.firstName} ${user.lastName}`}
    //                         </Box>
    //                     }
    //                 />
    //             </Grid>
    //         ))}
    //     </Grid>
    // </FormGroup>
  );



  // if (loading) return <div>Loading...</div>;
  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '200px' }}>
        <CircularProgress />
        {/* <span style={{ marginLeft: '10px' }}>Fetching testimonials...</span> */}
      </div>
    );
  }
  if (error) return <div>
    <div style={{marginBottom: '15px'}}>{error}</div>
      <Button
        variant="outlined"
        color="secondary"
        size="large"
        onClick={handleCancel}
      >
        Back
      </Button>
    </div>;

  return (
    <Box p={'24px 24px 24px 0px'} bgcolor="background.paper">
      <Box sx={{ mb: 2 }}>
        <Typography variant="h2">Create Projects</Typography>
      </Box>

      <Divider />

      <form onSubmit={formik.handleSubmit}>
        <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }}>
          <Box mt={3} flex={1}>
            <Box display="flex" alignItems="center" gap={1} mb={1}>
              <Typography variant="subtitle1">Number of Projects</Typography>
              <Tooltip title="How many projects to create" arrow>
                <IconButton size="small">
                  <InfoIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
            <TextField
              fullWidth
              type="number"
              name="numProjects"
              value={formik.values.numProjects}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.numProjects && Boolean(formik.errors.numProjects)}
              helperText={formik.touched.numProjects && formik.errors.numProjects}
              InputProps={{ inputProps: { min: 1 } }}
            />
            {/* <FormControl fullWidth error={formik.touched.numProjects && Boolean(formik.errors.numProjects)}>
                <Box display="flex" alignItems="center" gap={1} mb={1}>
                    <Typography variant="subtitle1">Number of Projects</Typography>
                    <Tooltip title="How many projects to create" arrow>
                    <IconButton size="small">
                        <InfoIcon fontSize="small" />
                    </IconButton>
                    </Tooltip>
                </Box>

                <Select
                    name="numProjects"
                    value={formik.values.numProjects}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    displayEmpty
                >
                    <MenuItem value="" disabled>Select number</MenuItem>
                    {[4, 12, 24].map((num) => (
                    <MenuItem key={num} value={num}>{num}</MenuItem>
                    ))}
                </Select>

                <FormHelperText>
                    {formik.touched.numProjects && formik.errors.numProjects}
                </FormHelperText>
            </FormControl> */}
          </Box>

            <Box mt={3} flex={1}>
                <Box display="flex" alignItems="center" gap={1} mb={1}>
                    <Typography variant="subtitle1">Start Date</Typography>
                    <Tooltip title="Start date (future only)" arrow>
                    <IconButton size="small">
                        <InfoIcon fontSize="small" />
                    </IconButton>
                    </Tooltip>
                </Box>

                <DatePicker
                    selected={formik.values.purchaseDate}
                    // onChange={(date) => formik.setFieldValue('purchaseDate', date)}
                    onChange={(date) => {
                      console.log('onlyDate before', date.getFullYear(), date.getMonth(), date.getDate())
                      const onlyDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                      console.log('onlyDate after mew create', onlyDate)
                      formik.setFieldValue("purchaseDate", onlyDate);
                    }}
                    onBlur={formik.handleBlur}
                    minDate={today}
                    dateFormat="MMMM d, yyyy"
                    placeholderText="Select a Start date"
                    customInput={
                        <TextField
                            fullWidth
                            name="purchaseDate"
                            value={
                            formik.values.purchaseDate
                                ? formik.values.purchaseDate.toLocaleDateString()
                                : ''
                            }
                            error={formik.touched.purchaseDate && Boolean(formik.errors.purchaseDate)}
                            helperText={formik.touched.purchaseDate && formik.errors.purchaseDate}
                        />
                    }
                />
            </Box>

          <Box mt={3} flex={1}>
            <Box display="flex" alignItems="center" gap={1} mb={1}>
              <Typography variant="subtitle1">Monthly Due Date</Typography>
              <Tooltip title="projects due date" arrow>
                <IconButton size="small">
                  <InfoIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
            <DatePicker
              selected={formik.values.dueDate}
              onChange={(date) => formik.setFieldValue('dueDate', date)}
              onBlur={formik.handleBlur}
              minDate={today}
              dateFormat="MMMM d, yyyy"
              placeholderText="Select a due date"
              customInput={
                <TextField
                  fullWidth
                  name="dueDate"
                  value={
                    formik.values.dueDate
                      ? formik.values.dueDate.toLocaleDateString()
                      : ''
                  }
                  error={formik.touched.dueDate && Boolean(formik.errors.dueDate)}
                  helperText={formik.touched.dueDate && formik.errors.dueDate}
                />
              }
            />
          </Box>
        </Box>

        <Box mt={4}>
          <Typography variant="h4" fontWeight={500}>
            Add Users
          </Typography>
          <Grid container spacing={2} mt="0px">
            <Grid item xs={12} sm={6}>
              <Typography fontSize="0.9rem" fontWeight={500} color="text.secondary" mb={1}>
                Customers
              </Typography>
                {isVpmaOrgFound ? renderUsers(customerUsers, 'customer')
                  :
                  renderSnapshotUsers(customerUsers, 'customer')
                }
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography fontSize="0.9rem" fontWeight={500} color="text.secondary" mb={1}>
                Production Team
              </Typography>
                {/* {renderUsers(asUsers, 'production')} */}
                {isVpmaOrgFound ? renderUsers(asUsers, 'production')
                  :
                  renderSnapshotUsers(asUsers, 'production')
                }
            </Grid>
          </Grid>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box display="flex" gap={2} maxWidth="450px">
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            size="large"
            disabled={isSubmitting}
            startIcon={isSubmitting && <CircularProgress size={20} color="inherit" />}
          >
            {isSubmitting ? 'Adding...' : '+ ADD SNAPSHOTS'}
          </Button>

          <Button
            variant="outlined"
            color="secondary"
            fullWidth
            size="large"
            onClick={handleCancel}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
        </Box>
      </form>
    </Box>
  );
}
